// Wide tables (prospects, leads) overflow their container on most screens, which
// scrolled the trailing Action column off the right edge — invisible on macOS,
// where overlay scrollbars give no hint that the row can scroll at all.
// Pin that column so its buttons are always reachable.

const stickyEdge = {
  position: 'sticky',
  right: 0,
  borderLeft: '1px solid',
  borderLeftColor: 'divider',
  boxShadow: '-6px 0 8px -8px rgba(15, 23, 42, 0.25)'
};

// Header cell — sits above both the body cells and any stickyHeader row.
// `bg` must be opaque and match the head background, since TableHead paints the
// <thead>, not the cells, and a transparent sticky cell lets rows scroll through.
export const stickyActionHead = (bg = 'background.default') => ({ ...stickyEdge, zIndex: 3, bgcolor: bg });

// Body cell — opaque so scrolled columns don't bleed through underneath.
export const stickyActionCell = { ...stickyEdge, zIndex: 1, bgcolor: 'background.paper', whiteSpace: 'nowrap' };
